import Transformer from './transformer';
import ProviderProfileTransformer from './providerProfile';

export default class ProviderPerformanceTransformer extends Transformer {
  /**
   * Method used to transform a fetched profile
   *
   * @param profile The fetched profile
   *
   * @returns {Object} The transformed profile
   */
  static fetchForTable(profile) {
    const reason = typeof profile.reason === 'string' ? JSON.parse(profile.reason) : profile.reason;
    return {
      id: profile.id,
      provider_profile_id: profile.provider_profile_id,
      current_performance: profile.current_performance,
      avatar: profile.avatar,
      fullName: ProviderProfileTransformer.fullName(profile),
      performance: profile.current_performance || 0,
      proposed_change: profile.proposed_change,
      status: profile.status,
      evaluation_start: profile.evaluation_start,
      evaluation_end: profile.evaluation_end,
      user: {
        id: profile.user.id,
        email: profile.user.email,
        tel: profile.user.tel,
      },
      reason: {
        total_appointment: reason.total_appointment,
        late_appointments: reason.late_appointments,
        cancelled_by_provider_appointments: reason.cancelled_by_provider_appointments,
        late_visit_note_appointments: reason.late_visit_note_appointments,
        average_rating: reason.average_rating,
        online_schedule_open_hour: reason.online_schedule_open_hour,
      },
    };
  }
}
